const state = {
  sideMenu: [],
  collapsed: null,
  routers: {},
  menus: [],
  permissions: {},
  projectId: null,
  users: {},
  allUsers: {},
  userInfo: {},
  globalConfigList: {},
  selectedNode: {},
  nodeMap: new Map(),
  design: {},
  pageSize: 20
};

export default state;
